import React from 'react';
// import Flex from 'components/common/Flex';
import LoginForm from 'components/authentication/LoginForm';

const Login = () => (
  <>
    <LoginForm />
  </>
);

export default Login;
